import { z } from 'zod';

export const companyInviteSchema = z.object({
  fullName: z.string().min(2, { message: 'Name is required.' }),
  email: z.string().email(),
  departments: z
    .array(
      z.object({
        value: z.number(),
        label: z.string(),
      }),
    )
    .min(1, { message: 'At least one department is required.' }),
});

export type ICompanyInviteForm = z.infer<typeof companyInviteSchema>;
